export default {
    beforeRouteLeave(to, from, next) {
        if (this.hasChanges) {
            this.$confirm(
                "There are unsaved changes. Are you sure you want to navigate away?",
                "Warning",
                {
                    confirmButtonText: "OK",
                    cancelButtonText: "Cancel",
                    type: "warning",
                }
            )
                .then(() => {
                    next();
                })
                .catch(() => next(false));
        } else {
            next();
        }
    },
    data() {
        return {
            oldData: null,
        };
    },
    computed: {
        hasChanges() {
            if (!this.oldData) {
                return false;
            }
            return this.oldData !== this.getCleanFormData();
        },
    },
    methods: {
        initOldData() {
            this.oldData = this.getCleanFormData();
        },
        getCleanFormData() {
            return JSON.stringify({});
        },
    },
};
